export default __webpack_public_path__ + "static/media/robot_rodeo.941f70a2.svg";